import { Grid } from "@mui/material";
import React, { useMemo } from "react";
import ToggleDrawer from "../../contexts/ToggleDrawer";
import { PETS } from "../../enums/QueryKeys";
import { petViewUrl } from "../../enums/UrlPaths";
import AddPetForm from "../../features/pets/form/AddPetForm";
import usePrimaryColor from "../../hooks/usePrimaryColor";
import useUser, { useGetUserId } from "../../hooks/useUser";
import ErrorFullScreenMessage from "../fullScreenMessage/ErrorFullScreenMessage";
import Skeletons from "../loader/Skeletons";
import EntityDrawer from "../wrappers/EntityDrawer";
import EntityCard from "./EntityCard";
import { isUnknownGender, useUnknownGenderColor } from "../../features/pets/utils/Functions";

export default function PetsGrid({
  petsArray,
  loading,
  error,
  mt = 2,
  spacing = 2,
  refetchData,
  displayForm = false,
  hasPermission,
  mutationKey = PETS,
  ownerId,
}) {
  const { profile, roles, isLoading, error: userError } = useUser();
  const loggedInUserId = useGetUserId();
  // Clinic staff list clinic-owned pets, which have no user owner
  const id = ownerId ? ownerId : roles.adminOrEmployee ? null : loggedInUserId;
  const color = usePrimaryColor();
  const unknownGenderColor = useUnknownGenderColor();
  const convert = petsArray?.map((pet) => {
    return {
      id: pet?.id,
      title: pet?.name,
      notification: pet?.hasUpcomingAppointments,
      icon: pet?.icon,
      gender: pet?.gender,
      deceased: pet?.deceased,
      active: pet?.active,
      avatar: pet?.avatar,
    };
  });
  const condition = hasPermission && displayForm;
  const petsGrid = useMemo(
    () =>
      convert?.map((pet) => {
        return (
          <Grid
            item
            xs={6}
            sm={3}
            md={3}
            lg={2}
            key={pet.id}
            justifyContent={{ xs: "center" }}
            display={"flex"}
          >
            <EntityCard
              data={pet}
              link={petViewUrl(pet.id, id)}
              showNotification={pet.notification}
              color={
                pet?.active === false
                  ? "orange"
                  : isUnknownGender(pet?.gender)
                    ? unknownGenderColor
                    : pet?.gender === "MALE"
                      ? color
                      : "hotpink"
              }
              testId={`pet.grid-card.${pet?.id}`}
            />
          </Grid>
        );
      }),
    [convert],
  );

  if (isLoading || loading) {
    return <Skeletons numOfSkeletons={petsArray?.length || 6} height={30} />;
  } else if (userError) {
    return <ErrorFullScreenMessage />;
  }

  return (
    <Grid
      container
      mt={mt}
      spacing={{ xs: spacing, sm: spacing, md: 3, lg: 4 }}
    >
      {condition ? (
        <ToggleDrawer>
          <Grid
            item
            xs={6}
            sm={3}
            md={3}
            lg={2}
            justifyContent={{ xs: "center" }}
            display={"flex"}
          >
            <EntityDrawer title={"Add"} testId="pet.drawer">
              <AddPetForm mutationKey={mutationKey} />
            </EntityDrawer>
          </Grid>
        </ToggleDrawer>
      ) : null}

      {petsGrid}
    </Grid>
  );
}
